const { on } = require('hammerjs');

(function () {
  class SymbolFrameDisplay extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      StateMachine.Create(this);
    }

    initialise() {
      this._callback = undefined;
      this._path = this.name + ':symbolFrameDisplayContainer';
      this._framePanels = [];
      this._anticipationPanels = [];

      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    playFrameAnims(symbols) {
      for (let i = 0; i < symbols.length; i++) {
        this.playFrameAnim(symbols[i].reel, symbols[i].row);
      }
    }

    playFrameAnim(reel, row) {
      this._framePanels[reel][row].visible = true;
      this._framePanels[reel][row].gotoAndPlay(0);
    }

    stopSymbolFrameAnims() {
      for (let reel = 0; reel < this._framePanels.length; reel++) {
        for (let row = 0; row < this._framePanels[reel].length; row++) {
          this._framePanels[reel][row].visible = false;
          this._framePanels[reel][row].gotoAndStop(0);
        }
      }
    }

    playAnticipationAnim(reel) {
      // this._anticipationPanels[reel].visible = true;
      // this._anticipationPanels[reel].gotoAndPlay(0);
    }

    stopAnticipationAnim(reel, time) {
      // if (this._anticipationPanels[reel].playing) {
      //   gsap.to(this._anticipationPanels[reel], {
      //     duration: time,
      //     alpha: 0,
      //     ease: 'none',
      //     onComplete: () => {
      //       this._anticipationPanels[reel].visible = false;
      //       this._anticipationPanels[reel].gotoAndStop(0);
      //       this._anticipationPanels[reel].alpha = 1;
      //     },
      //   });
      // }
    }

    onLayoutComplete() {
      for (let reel = 0; reel < gameData.NUM_REELS; reel++) {
        let panelRow = [];
        for (let row = 0; row < gameData.NUM_ROWS; row++) {
          let pos = helpers.getSymbolPos(reel, row, true);

          let frameAnim = resourceManager.createObject('movie', 'frameAnim_' + reel + '_' + row, this._path, {
            definition: 'symbolFrame',
            x: pos.x,
            y: pos.y,
            anchor: 0.5,
            loop: false,
            scaleX: 1,
            scaleY: 1.08,
          });
          frameAnim.gotoAndStop(0);
          frameAnim.visible = false;
          // frameAnim.blendMode = PIXI.BLEND_MODES.ADD;

          panelRow.push(frameAnim);
        }
        this._framePanels.push(panelRow);

        let posAbove = helpers.getSymbolPos(reel, 1, true);
        let posBelow = helpers.getSymbolPos(reel, 2, true);
        let gap = posBelow.y - posAbove.y;

        // let anticipationAnim = resourceManager.createObject('movie', 'anticipationAnim_' + reel, this._path, {
        //   definition: 'anticipationAnim',
        //   x: posAbove.x,
        //   y: posAbove.y + gap / 2,
        //   anchor: 0.5,
        //   loop: true,
        //   scale: 2,
        // });
        // anticipationAnim.gotoAndStop(0);
        // anticipationAnim.visible = false;
        // anticipationAnim.blendMode = PIXI.BLEND_MODES.ADD;

        // this._anticipationPanels.push(anticipationAnim);
      }
    }
  }

  create = function (json) {
    return new SymbolFrameDisplay();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('symbolFrameDisplay', create, initialise, getFilesRequired);
})();
